"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderMaxPax = void 0;
const getOrderLinePax_1 = require("./getOrderLinePax");
const getOrderMaxPax = (order) => {
    if (!order)
        return 0;
    if (!order.order_lines)
        return 0;
    return order.order_lines.reduce((acc, cur) => {
        const maxPax = (0, getOrderLinePax_1.getOrderLinePax)(cur);
        return Math.max(acc, maxPax);
    }, 0);
};
exports.getOrderMaxPax = getOrderMaxPax;
